import React from 'react';
import { Row } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Fields } from 'redux-form';
import AdultIndividualV2 from './AdultIndividualV2';
import messages from './messages';
import { curryN } from 'ramda';

type Props = {
  fields: Fields,
  meta: {
    error: Object,
  },
  intl: any,
  suffixes: Array<Object>,
  relationships: Array<Object>,
  change: Function,
};

const AdultRows = ({
  fields,
  meta: { error },
  intl,
  suffixes,
  relationships,
  change,
}: Props) => {
  const fieldRemoveCurried = curryN(2, fields.remove);
  const renderRows =
    fields && fields.length > 0
      ? fields.map((adult, index) => (
          <AdultIndividualV2
            intl={intl}
            key={index}
            adult={adult}
            onDelete={fieldRemoveCurried(index)}
            suffixes={suffixes}
            relationships={relationships}
            change={change}
          />
        ))
      : null;

  return (
    <div>
      {renderRows}
      {fields.length < 10 && (
        <Row>
          <a className="btn-text" onClick={() => fields.push()}>
            <FormattedMessage {...messages.addDetail} />
          </a>
        </Row>
      )}
    </div>
  );
};

export default AdultRows;
